import Vue from 'vue'
import { login, queryPermissionsByUser } from '../../api/api'
import {
  ACCESS_TOKEN,
  COMPONENTS_NAME,
  MENU_NAME,
  USER_INFO
} from '../mutation-types'
import { constantRouterMap } from '../../router'
import { handleUpdate } from '@/utils/configRoles'
import { redirectToWxAuth } from '../../utils/util'

const user = {
  state: {
    accessToken: null,
    permissionList: [],
    routers: constantRouterMap,
    addRouters: [],
    userComponents: [],
    userInfo: {}
  },

  mutations: {
    SET_ACCESS_TOKEN: (state, accessToken) => {
      state.accessToken = accessToken
    },
    SET_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_PERMISSIONLIST: (state, permissionList) => {
      state.permissionList = permissionList
    },
    SET_USER_COMPOENTS: (state, userComponents) => {
      state.userComponents = userComponents
    },
    SET_ROUTERS: (state, data) => {
      state.addRouters = data
      state.routers = constantRouterMap.concat(data)
    },
  },

  actions: {
    // 登录
    Login ({ commit }, iepLoginId) {
      return new Promise((resolve, reject) => {
        login({
          'loginId': iepLoginId,
          'clientId': 2
        }).then(response => {
          if (response && response.code === 0) {
            const result = response.data
            window && localStorage.removeItem('sessionId')
            commit('SET_ACCESS_TOKEN', result.accessToken)
            Vue.ls.set(ACCESS_TOKEN, result.accessToken)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 重新登录清除旧数据
    delStorage ({ commit }) {
      commit('SET_ACCESS_TOKEN', '')
      Vue.ls.set(ACCESS_TOKEN, '')

      commit('SET_INFO', {})
      Vue.ls.set(USER_INFO, {})

      Vue.ls.set(MENU_NAME, [])
      commit('SET_PERMISSIONLIST', [])

      Vue.ls.set(COMPONENTS_NAME, [])
      commit('SET_USER_COMPOENTS', [])

      commit('SET_ROUTERS', [])
    },
    // 登出
    Logout ({ commit }) {
      commit('SET_ACCESS_TOKEN', '')
      Vue.ls.set(ACCESS_TOKEN, '')

      commit('SET_INFO', {})
      Vue.ls.set(USER_INFO, {})

      Vue.ls.set(MENU_NAME, [])
      commit('SET_PERMISSIONLIST', [])

      Vue.ls.set(COMPONENTS_NAME, [])
      commit('SET_USER_COMPOENTS', [])

      commit('SET_ROUTERS', [])

      window && window.localStorage.setItem('redirectURL', `${window.location.pathname}${window.location.search}`)
      // 前端直接跳转微信授权
      redirectToWxAuth()
    },
    // 获取用户权限
    GetPermissionList ({ commit }) {
      return new Promise((resolve, reject) => {
        queryPermissionsByUser().then(response => {
          const result = response.data
          // 保存用户信息
          commit('SET_INFO', result.userInfo)
          Vue.ls.set(USER_INFO, result.userInfo)
          handleUpdate(result.userInfo)
          // 在这里需要根据菜单类型 将资源类型只菜单的筛选出来
          const menuData = result.menus
          Vue.ls.set(MENU_NAME, menuData)
          if (menuData && menuData.length > 0) {
            commit('SET_PERMISSIONLIST', menuData)
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('getPermissionList: permissions must be a non-null array !')
          }
          resolve(menuData)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateAppRouter ({ commit }, { routers, components }) {
      return new Promise(resolve => {
        Vue.ls.set(COMPONENTS_NAME, components)
        commit('SET_USER_COMPOENTS', components)

        let routelist = routers
        commit('SET_ROUTERS', routelist)
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js